/* eslint-disable import/prefer-default-export */
export var transitionSpeed = '0.15s';
/* eslint-enable import/prefer-default-export */